import {
  Component, OnInit,
  Input, ChangeDetectionStrategy, Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef
} from '@angular/core';
import find from 'lodash-es/find';

import { FilterSorter, FilterSorterCriterias } from '@shared/filters/entities/fetch-filters.response';
import { SorterTypes } from '@shared/filters/entities/sorter-options';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import { RadioButtonAlign } from '@design-system/components/organisms/radio-button/entities/radio-button.types';

@Component({
  selector: 'app-sorter-filter',
  templateUrl: './sorter-filter.component.html',
  styleUrls: ['./sorter-filter.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SorterFilterComponent implements OnInit, OnChanges {

  @Input() label: string;
  @Input() pickedSorter: FilterSorterCriterias = {} as FilterSorterCriterias;
  @Input() sorters: FilterSorter[] = [];
  @Input() individualFilter = false;
  @Input() isMobile = false;

  @Output() sorter: EventEmitter<FilterSorter> = new EventEmitter<FilterSorter>();

  public radioSelected: string;
  public isOpenBox: boolean = true;

  constructor(private changeDetector: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.setRadioSelected();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['pickedSorter']) {
      this.setRadioSelected();
      this.detectChanges();
    }
  }

  get radioButtonAlign(): RadioButtonAlign {
    return this.isMobile ? RadioButtonAlign.Right : RadioButtonAlign.Left;
  }

  public isChecked(option: string): boolean {
    return option === this.radioSelected;
  }

  public select(item: FilterSorter): void {
    this.sorter.emit(item);
  }

  public toggleCheckboxOptions(): void {
    this.isOpenBox = !this.isOpenBox;
  }

  public sorterIcon(sorter: FilterSorterCriterias): Icon {
    switch (sorter.OrderCriteria) {
      case SorterTypes.Price:
        return sorter.OrderDesc ? Icon.Expensive : Icon.MoneyIcon;
      case SorterTypes.Duration:
        return Icon.Clock;
      case SorterTypes.Recommended:
        return Icon.Check;
      case SorterTypes.DiscountPercentage:
        return Icon.Promotion;
      case SorterTypes.Category:
        return Icon.Star;
      default:
        return Icon.Check;
    }
  }

  private setRadioSelected(): void {
    const sorter: FilterSorter = find(this.sorters, {
      OrderCriteria: this.pickedSorter.OrderCriteria,
      OrderDesc: this.pickedSorter.OrderDesc
    });
    this.radioSelected = sorter?.Label;
  }

  private detectChanges(): void {
    this.changeDetector.detectChanges();
  }
}
